// @mui
import { LoadingButton } from '@mui/lab';
import { Popover, Typography, useTheme } from '@mui/material';
import { MouseEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/iconify';
import { DARK_TEXT } from 'src/theme/palette';
import { GetVisitById, PaymentStatusEnum } from 'woofwoof-api';

// ---------------------------------------------------------------------

type UserUpcomingVisitCardRescheduleButtonProps = {
  visit: GetVisitById;
  onEdit?: (visitId: string) => void;
  isRescheduleOrCancelAvailable?: boolean;
  isCancelLoading?: boolean;
  isRescheduleLoading?: boolean;
  disabled?: boolean;
  type?: 'submit';
  isIcon?: boolean;
  size?: 'small' | 'medium' | 'large';
};

export default function UserUpcomingVisitCardEditButton({
  visit,
  onEdit,
  isRescheduleOrCancelAvailable,
  isCancelLoading,
  isRescheduleLoading,
  disabled,
  type,
  isIcon,
  size,
}: UserUpcomingVisitCardRescheduleButtonProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isPaymentFailed = visit?.payment?.status === PaymentStatusEnum.Failed;
  const isPaymentPending = visit?.payment?.status === PaymentStatusEnum.Created;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handlePopoverOpen = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      !isRescheduleOrCancelAvailable && setAnchorEl(event.currentTarget);
    },
    [isRescheduleOrCancelAvailable],
  );

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleOnEditVisitClick = () => onEdit && onEdit(visit.id);

  return (
    <>
      <span
        aria-owns={open ? 'edit-popover' : undefined}
        aria-haspopup="true"
        // onMouseEnter={handlePopoverOpen}
        // onMouseLeave={handlePopoverClose}
        style={{ display: 'inline-flex' }}
      >
        <LoadingButton
          type={type}
          fullWidth
          size={size || 'medium'}
          variant="contained"
          sx={{
            background: theme.palette.common.black,
            color: DARK_TEXT.primary,
          }}
          startIcon={isIcon ? <Iconify icon="ic:edit" /> : undefined}
          onClick={handleOnEditVisitClick}
          disabled={
            isPaymentFailed ||
            isPaymentPending ||
            // !isRescheduleOrCancelAvailable ||
            isCancelLoading ||
            isRescheduleLoading ||
            disabled
          }
        >
          {type === 'submit' ? t('common.save') : t('visit.rescheduleVisit')}
        </LoadingButton>
      </span>
      <Popover
        id="edit-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography variant="body2" sx={{ p: 1, maxWidth: '350px' }}>
          {t('visit.editMinHoursNotice')}
        </Typography>
      </Popover>
    </>
  );
}
